module.exports = __webpack_public_path__ + "img/echo-logo.d623ba4a.svg";